<template>
  <span v-hover-tip="placeName">
    <img v-if="logo" :src="logo" style="width: 18px; height: 18px; vertical-align: middle" />
    <md-icon v-else style="font-size: 18px !important; vertical-align: middle">warehouse</md-icon>
    {{ displayName || placeName }}
  </span>
</template>
<script>
import hoverTip from "@/components/HoverTip/hoverTipDirective";

export default {
  name: "DestinationInfo",
  directives: { hoverTip },
  props: {
    placeName: {
      type: String,
    },
    placeId: {
      type: Number,
    },
    displayName: {
      type: String,
    },
  },
  computed: {
    containerArrivalPlaceOptions() {
      return this.$store.state.shippingData.containerArrivalPlaces || [];
    },
    logo() {
      const carrier = this.containerArrivalPlaceOptions.find((i) => i.id === this.placeId);
      return carrier && carrier.logo;
    },
  },
};
</script>
<style></style>
